import { Link } from "react-router-dom";
import type { Business } from "@/types/directory";
import BusinessCard from "@/components/base/BusinessCard";

interface SponsoredListingsProps {
  businesses: Business[];
}

export default function SponsoredListings({ businesses }: SponsoredListingsProps) {
  if (businesses.length === 0) {
    return null;
  }

  return (
    <section className="border-y border-[#1B3E68] bg-gradient-to-br from-[#0B2545] via-[#12335C] to-[#0B2545]">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-14 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-[#FFC24B] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#0B2545]">
              <span className="flex h-4 w-4 items-center justify-center text-[#0B2545]">
                <i className="ri-megaphone-line text-sm" />
              </span>
              Sponsored
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-white md:text-3xl">
              Sponsored businesses on the coast
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[#BFD4EA] md:text-base">
              Local businesses that booked a sponsored placement to get seen first. Every sponsored
              listing is clearly labelled, and relevance is never overridden.
            </p>
          </div>

          <div className="flex shrink-0 flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-semibold text-white">
              <span className="flex h-4 w-4 items-center justify-center text-[#FFC24B]">
                <i className="ri-star-smile-line text-sm" />
              </span>
              {businesses.length} sponsored spots
            </span>
            <Link
              to="/listing-plans"
              className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-[#FFC24B] px-4 py-2.5 text-sm font-semibold text-[#0B2545] transition-colors duration-200 hover:bg-[#FFD06E]"
            >
              Advertise here
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5" />
              </span>
            </Link>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {businesses.map((business) => (
            <BusinessCard key={business.id} business={business} clickableCard />
          ))}
        </div>
      </div>
    </section>
  );
}